export default "__VITE_ASSET__VfPzoulk__"